import {store} from '../stores';

const register = (app) => {
    app.directive('permit', {

        created(el, bindings) {

            let hasPermission = true;
    
            let accessUser = store.getters['auth/accessUser'];
    
            if (accessUser.account_type.id == 1) return true;
    
            const permissions = accessUser.permissions;
    
            const action = bindings.arg;
    
            const bindValue = bindings.value;
    
            if (typeof bindValue === 'string')
            {
                const permission = permissions.find(row => row.module.route_name == bindValue);
    
                hasPermission = permission && permission[action];
            }
    
            else if (typeof bindValue === 'object')
            {
                for(let i in bindValue)
                {
                    const permission = permissions.find(row => row.module.route_name == bindValue[i]);
    
                    hasPermission = permission && permission[action];
    
                    if (hasPermission) break;
                }
            }
            
            if (!hasPermission) el.style.display = 'none';
        },
    });

    app.directive('click-outside', {
        mounted: (el, binding) => {
            el.clickOutsideEvent = event => {
              // here I check that click was outside the el and his children
              if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                binding.value();
              }
            };
            document.addEventListener("click", el.clickOutsideEvent);
          },
          unmounted: el => {
            document.removeEventListener("click", el.clickOutsideEvent);
          },
    })
};

export default {
    register,
};